import { axios } from "utilities/axios";
import { ITagModel, Route } from "@edgetier/watchtower-types";

/**
 * Create a tag model and then get it. The create and then get is in case there are race conditions.
 * @param tagId Tag for the model.
 * @returns     New model's ID.
 */
export const postTagModel = async (tagId: string) => {
    try {
        const { data } = await axios.post<ITagModel>(Route.TagModels, { tagId });
        return data.modelId;
    } catch {
        // Get the model if the POST failed in case of a race condition (two requests making the same tag).
        const { data } = await axios.get<ITagModel[]>(Route.TagModels, { params: { tagId } });
        if (data.length > 0) {
            return data[0].modelId;
        }
        return null;
    }
};
